import { get, some } from 'lodash'
import { ComponentTypes, listAllControllers } from '@wix/wix-data-client-common'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

interface Params {
  componentRef: ComponentRef
  editorSdkProxy: EditorSDK
}

export const getRepeaterAncestor = async function ({
  componentRef,
  editorSdkProxy,
}: Params) {
  const isInsideRepeater = await editorSdkProxy.components.isRepeatedComponent({
    componentRef,
  })
  if (!isInsideRepeater) {
    return null
  }

  const ancestorsRefs = await editorSdkProxy.components.getAncestors({
    componentRef,
  })

  const ancestors = await editorSdkProxy.components.get({
    componentRefs: ancestorsRefs,
    properties: ['sdkType', 'connections'],
  })
  const firstRepeaterAncestor = ancestors.find(
    ({ sdkType }: { sdkType: string }) => sdkType === ComponentTypes.Repeater,
  )
  if (!firstRepeaterAncestor) {
    return null
  }

  const allDatasets = await listAllControllers(editorSdkProxy)
  const databindingConnections = firstRepeaterAncestor.connections.filter(
    ({ controllerRef }: { controllerRef: ComponentRef }) =>
      some(allDatasets, { controllerRef }),
  )

  return {
    componentRef: firstRepeaterAncestor.componentRef,
    controllerRef: get(databindingConnections, [0, 'controllerRef'], null),
  }
}
